export class DocumentParser {
  constructor (adapter) {
    this.adapter = adapter
  }

  async parse (base64) {
    return await this.adapter.parse(base64)
  }
}

export class DocumentParserAdapter {
  async parse (base64) {
    throw new Error('NOT_IMPLEMENTED')
  }
}
